import { render } from "./index.vue?vue&type=template&id=26c9d846&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=26c9d846&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c9d846"],['__file',"src/views/Membership/component/PrivacySettings/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26c9d846"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26c9d846', __exports__)) {
    api.reload('26c9d846', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=26c9d846&scoped=true", () => {
    api.rerender('26c9d846', render)
  })

}


export default __exports__